export default "__VITE_ASSET__DBhnByMd__"